<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-dog-data-provider
            v-slot="dogScope"
            :dog-id="dogId"
        >
            <div class="animated fadeIn">
                <kgr-dog-profile
                    :dog="dogScope.data"
                />
            </div>
        </kgr-dog-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import KgrDogDataProvider from '../../components/data-provider/DogDataProvider.vue';
import KgrDogProfile from '../../components/dog/DogProfile.vue';
import KgrFormScaffold from '../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': KgrFormScaffold,
        'kgr-dog-data-provider': KgrDogDataProvider,
        'kgr-dog-profile': KgrDogProfile,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        dogId: {
            type: String,
            required: true,
        },
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
